/**
 * Conversion factors to base units (bytes for storage, seconds for time)
 * @returns Object with conversion factors
 *
 * @author Claude Code
 */

import {StorageUnit, TimeUnit} from './feature-constants.enum';

export const getConversionFactors = (): {[key: string]: number} => ({
	// Storage conversions to bytes
	[StorageUnit.TB]: 1024 * 1024 * 1024 * 1024,
	[StorageUnit.GB]: 1024 * 1024 * 1024,
	[StorageUnit.MB]: 1024 * 1024,
	[StorageUnit.KB]: 1024,
	bytes: 1,
	// Time conversions to seconds
	[TimeUnit.Hours]: 3600,
	[TimeUnit.Minutes]: 60,
	[TimeUnit.Seconds]: 1,
	// Count (no conversion needed)
	count: 1,
});
